import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/thoughts-feed/components/ThoughtsFeedInteractive.tsx");
